var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00003 2C3.81657 2 2.85718 2.95939 2.85718 4.14286C2.85718 5.32632 3.81657 6.28571 5.00003 6.28571C6.1835 6.28571 7.14289 5.32632 7.14289 4.14286C7.14289 2.95939 6.1835 2 5.00003 2Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.71423C9.81657 9.71423 8.85718 10.6736 8.85718 11.8571C8.85718 13.0406 9.81657 13.9999 11 13.9999C12.1835 13.9999 13.1429 13.0406 13.1429 11.8571C13.1429 10.6736 12.1835 9.71423 11 9.71423Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85714 12.2857H7.57143C6.15127 12.2857 5 11.1344 5 9.71423V6.71423",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubTask);
export default __webpack_public_path__ + "static/media/subTask.bf20f716cb78e701fb6d60ee66b14487.svg";
export { ForwardRef as ReactComponent };